import { type ChangeEventHandler } from 'react'

import { SELECT_ITEM_USE_SCANNED_NAME } from './constants'
import { type ExistingApplicantNameInputProps } from './existing-applicant-name-input'

export type UseExistingApplicantNameInputParams = ExistingApplicantNameInputProps

export const INPUT_MAX_LENGTH = 50

export const useExistingApplicantNameInput = ({
  ocrScannedValue,
  matchingValue,
  disabled = false,
  onChangeScannedValue,
  onChangeMatchingValue,
}: UseExistingApplicantNameInputParams) => {
  const usesScannedName = !matchingValue || matchingValue === SELECT_ITEM_USE_SCANNED_NAME.value

  const isDisabledOCRScannedNameInput =
    disabled || (!!matchingValue && matchingValue !== SELECT_ITEM_USE_SCANNED_NAME.value)
  const isDisabledSelectApplicantInput = disabled

  const handleChangeScannedInput: ChangeEventHandler<HTMLInputElement> = (e) => {
    const inputValue = e.target.value
    onChangeScannedValue(inputValue.slice(0, INPUT_MAX_LENGTH))
  }

  const handleChangeSelectedValue = (value: string) => {
    onChangeMatchingValue(value)
  }

  return {
    ocrScannedValue,
    matchingValue,
    usesScannedName,
    isDisabledOCRScannedNameInput,
    isDisabledSelectApplicantInput,
    handleChangeScannedInput,
    handleChangeSelectedValue,
  }
}
